import { JsonLayerResponse } from '@/interfaces/jsonLayerResponse';
import { JsonLayerChartStyle, isJsonLayerChartStyle } from '@/interfaces/json-layer-responses/jsonLayerChartStyle';

interface FetchDefaultChartStyleResponse extends JsonLayerResponse {
  chartStyle: JsonLayerChartStyle;
}

export function isFetchDefaultChartStyleResponse(jsonLayerResponse: JsonLayerResponse): jsonLayerResponse is FetchDefaultChartStyleResponse {
  return (
    'chartStyle' in jsonLayerResponse &&
    isJsonLayerChartStyle(jsonLayerResponse.chartStyle)
  );
}
